export enum Rhythmicity { 
    RegularRoutines = 1,
    IrregularRoutines = 3
    }